import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import SectionHeading from "@/components/feature/SectionHeading";
import FeatureGrid from "@/components/feature/FeatureGrid";
import ProcessSteps from "@/components/feature/ProcessSteps";
import FaqAccordion from "@/components/feature/FaqAccordion";
import SolucoesHero from "@/pages/solucoes/components/SolucoesHero";
import SolucoesIntro from "@/pages/solucoes/components/SolucoesIntro";
import ServiceShowcase from "@/pages/solucoes/components/ServiceShowcase";
import SolucoesFlow from "@/pages/solucoes/components/SolucoesFlow";
import SolucoesAudience from "@/pages/solucoes/components/SolucoesAudience";
import SolucoesCombos from "@/pages/solucoes/components/SolucoesCombos";
import SolucoesCta from "@/pages/solucoes/components/SolucoesCta";
import SolucoesQuickQuote from "@/pages/solucoes/components/SolucoesQuickQuote";
import {
  solucoesServices,
  whyCards,
  solucoesProcess,
  solucoesFaqs,
} from "@/mocks/solucoes";

export default function Solucoes() {
  return (
    <SiteLayout>
      <Seo
        title="Soluções Digitais | Sites, Hospedagem, VPS, SEO e Marketing | NXHOST"
        description="Soluções digitais para empresas: criação de sites, hospedagem, VPS, lojas virtuais, SEO, marketing digital, Google Ads e muito mais. Conheça a NXHOST."
        keywords="soluções digitais, criação de sites, hospedagem de sites, VPS, loja virtual, e-commerce, SEO, marketing digital, Google Ads, landing pages, domínio e e-mail profissional"
        path="/solucoes"
        titleEn="Digital Solutions | Websites, Hosting, VPS, SEO and Marketing | NXHOST"
        titleEs="Soluciones Digitales | Sitios Web, Hosting, VPS, SEO y Marketing | NXHOST"
        descriptionEn="Digital solutions for companies: website creation, hosting, VPS, online stores, SEO, digital marketing and Google Ads. Get to know NXHOST."
        descriptionEs="Soluciones digitales para empresas: creación de sitios web, hosting, VPS, tiendas online, SEO, marketing digital y Google Ads. Conoce NXHOST."
        breadcrumbs={[
          { name: "Início", path: "/" },
          { name: "Soluções Digitais", path: "/solucoes" },
        ]}
        faqs={solucoesFaqs}
      />

      <SolucoesHero />
      <SolucoesIntro />

      {solucoesServices.map((service, index) => (
        <ServiceShowcase
          key={service.id}
          service={service}
          reverse={index % 2 === 1}
          alt={index % 2 === 1}
        />
      ))}

      <SolucoesFlow />

      <section className="bg-background-50 py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <SectionHeading
            badge="Por que escolher a NXHOST"
            badgeIcon="ri-shield-star-line"
            title="Tecnologia e estratégia para o seu negócio"
            description="Mais do que criar páginas, ajudamos a estruturar a presença digital da sua empresa com foco em resultado."
          />
          <div className="mt-12">
            <FeatureGrid items={whyCards} columns={3} accent="primary" />
          </div>
        </div>
      </section>

      <SolucoesAudience />

      <SolucoesCombos />

      <section className="bg-background-100 py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <SectionHeading
            badge="Nosso processo"
            badgeIcon="ri-route-line"
            badgeTone="accent"
            title={solucoesProcess.title}
          />
          <div className="mt-12">
            <ProcessSteps steps={solucoesProcess.steps} />
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <SectionHeading
            badge="Dúvidas frequentes"
            badgeIcon="ri-question-line"
            title="Perguntas frequentes"
          />
          <div className="mt-12">
            <FaqAccordion items={solucoesFaqs} />
          </div>
        </div>
      </section>

      <SolucoesQuickQuote />

      <SolucoesCta />
    </SiteLayout>
  );
}